import client from './client';

export const listSessions = () => client.get('/v1/sessions/');
export const createSession = () => client.post('/v1/sessions/');
export const getSession = (id) => client.get(`/v1/sessions/${id}/`);
export const deleteSession = (id) => client.delete(`/v1/sessions/${id}/`);
export const getSessionQR = (id) => client.get(`/v1/sessions/${id}/qr/`);
export const restartSession = (id) => client.post(`/v1/sessions/${id}/restart/`);
export const relinkSession = (id) => client.post(`/v1/sessions/${id}/relink/`);
